document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;

  if (!currentPath.startsWith("/blog")) {
    return;
  }

  menuToggle(".blog-categories__box", ".btn__toggle");

  const links = document.querySelectorAll(
    ".blog-categories__box a.category__link"
  );

  let activeLink = null;

  links.forEach((link) => {
    const linkPath = new URL(link.href, window.location.origin).pathname;

    if (currentPath === linkPath || currentPath.startsWith(linkPath)) {
      link.classList.add("active");
      activeLink = link;
    } else {
      link.classList.remove("active");
    }
  });
});
